<img [src]="photo"
  *ngIf="photo">